import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Heading, Stack } from "native-base";
import { createDateRangeArray, groupByDay } from "@madmedical/utils";
import { useMemo } from "react";
import { InsulinPortioningGraph } from "../../../charts";
import Paper from "../../../atoms/Paper";
import useResponsive from "../../../util/useResponsive";
import DateRangePicker from "../../../organisms/DateRangePicker";
import { useInsulinAdministration } from "../../../providers/insulinAdministration";
import { useChart } from "../../../providers/chart";
import ListHeader from "../../../molecules/ListHeader";
const InsulinPortioningChart = () => {
    const { isSmallScreen } = useResponsive();
    const { dateRange } = useChart();
    const { bloodSugareAverages, administrations } = useInsulinAdministration();
    const graphData = useMemo(() => {
        const dateArray = createDateRangeArray(dateRange);
        const groupedAdministrations = groupByDay(administrations, "administeredAt");
        const maxValue = Math.max(...Object.values(bloodSugareAverages).map((item) => Math.ceil(item)));
        return dateArray.map((date) => {
            var _a, _b;
            const dateHours = date.setHours(0, 0, 0, 0);
            const insertions = (_b = (_a = groupedAdministrations[dateHours]) === null || _a === void 0 ? void 0 : _a.reduce((acc, curr) => {
                acc[curr.product.type] += curr.units;
                return acc;
            }, {
                rapid: 0,
                basal: 0,
                other: 0,
            })) !== null && _b !== void 0 ? _b : { rapid: 0, basal: 0, other: 0 };
            const fullArea = 240;
            const svgViewport = 170;
            const findValue = bloodSugareAverages[dateHours] > 0
                ? (bloodSugareAverages[dateHours] * fullArea) / maxValue
                : 0;
            const y = svgViewport + 1 - findValue;
            return {
                y,
                value: bloodSugareAverages[dateHours],
                status: "OK",
                insertions,
                administeredAt: new Date(dateHours),
            };
        });
    }, [dateRange, bloodSugareAverages, administrations]);
    return (_jsxs(Box, Object.assign({ width: "full" }, { children: [isSmallScreen && (_jsx(ListHeader, { title: "Inzulin adagol\u00E1s", size: "xs", borderBottomWidth: 0, bgColor: "none", px: 4 })), _jsxs(Paper, Object.assign({ borderTopLeftRadius: 0, borderTopRightRadius: 0 }, { children: [_jsxs(Stack, Object.assign({ alignItems: isSmallScreen ? "flex-start" : "center", direction: isSmallScreen ? "column" : "row", justifyContent: isSmallScreen ? "flex-start" : "between", space: 6, w: "full", borderBottomWidth: isSmallScreen ? 0 : 1, borderBottomColor: "gray.100", mb: 4, py: 2 }, { children: [!isSmallScreen && (_jsx(Box, Object.assign({ flex: "1", p: 6 }, { children: _jsx(Heading, Object.assign({ size: "xs", fontWeight: "medium", numberOfLines: 1, textTransform: "uppercase", color: "black" }, { children: "Inzulin adagol\u00E1s" })) }))), _jsx(Box, Object.assign({ p: 4 }, { children: _jsx(DateRangePicker, { periods: ["week", "month"] }, "portion") }))] })), graphData.length !== 0 && (_jsx(InsulinPortioningGraph, { pointData: graphData }))] }))] })));
};
export default InsulinPortioningChart;
